<template>
    <div class="lightbox-img">
        <a :href="srcs[0].url" :data-fancybox="'gallery-' + gallery" ref="triggerRef" class="relative block group z-0">
            <slot></slot>
        </a>

        <div class="hidden" v-if="srcs.length > 1">
            <template v-for="img in srcs">
                <a :data-fancybox="'gallery-' + gallery" :href="img.url">
                    <img :src="img.url" :alt="img.alt" />
                </a>
            </template>
        </div>
    </div>
</template>
<script setup>
    import { provide } from 'vue';

    const props = defineProps({
        thumbnail: { type: String, required: true },
        srcs: { type: Array, required: true },
        gallery: { type: String, required: true },
        video: { type: Boolean, default: false },
    });

    // Provide props to child components
    provide('lightbox', {
        thumbnail: props.thumbnail,
        srcs: props.srcs,
        video: props.video,
    });
</script>